export const currencies = [
  { value: 'SAR', text: 'SAR' },
  { value: 'USD', text: 'USD' },
  { value: 'EGP', text: 'EGP' },
  { value: 'EUR', text: 'EUR' }
]
